/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';
import { GeometryIdDto } from './geometryIdDto';
import { WorkstateTimeDto } from './workstateTimeDto';
import { MainAccountingDto } from './mainAccountingDto';

export interface MachineDataDto {
  duration?: number;
  durationFiredUp?: number;
  durationIdle?: number;
  durationWaiting?: number;
  durationWorked?: number;
  fuelConsumed?: number;
  geometry?: GeometryIdDto;
  ha?: number;
  km?: number;
  kmWorked?: number;
  machine?: MachineIdDto;
  mainAccounting?: MainAccountingDto;
  mainAccountingFuel?: MainAccountingDto;
  startDate?: string;
  workstateTimes?: Array<WorkstateTimeDto>;
}
